<template>
    <div class="section footer">
        <img src="assets/images/logo_flat_white.svg" alt="PlanIt Logo" />

        <div class="links">
            <div class="link-column">
                <router-link v-bind:to="{ name: 'Home' }">Home</router-link>
                <router-link v-bind:to="{ name: 'About' }">About Us</router-link>
                <router-link v-bind:to="{ name: 'TopDestinations' }">Top Destinations</router-link>
                <a href="#">Partners</a>
                <router-link v-bind:to="{ name: 'ContactUs' }">Contact Us</router-link>
            </div>

            <div class="link-column">
                <a href="#">My Account</a>
                <router-link v-bind:to="{ name: 'ExploreItineraries' }">Explore Itineraries</router-link>
                <a href="#">My Itineraries</a>
            </div>

            <div class="link-column">
                <router-link v-bind:to="{ name: 'FAQ' }">FAQs</router-link>
                <router-link v-bind:to="{ name: 'Terms' }">Terms of Use</router-link>
                <router-link v-bind:to="{ name: 'PrivacyPolicy' }">Privacy Policy</router-link>
            </div>
        </div>

        <div class="copyright-info">PlanIt © 2019 | All rights reserved</div>

        <div class="social-links">
            <a href="#">
                <img src="assets/images/icons/facebook_white.svg" class="social-link__icon" alt="Facebook Logo" />
            </a>
            <a href="#">
                <img src="assets/images/icons/twitter.svg" class="social-link__icon" alt="Twitter Logo" />
            </a>
            <a href="#">
                <img src="assets/images/icons/instagram.svg" class="social-link__icon" alt="Instagram Logo" />
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'AppFooter'
    }
</script>

<style scoped lang="scss">
    .footer {
        background-color: $navy;
        position: relative;
        padding: 40px 88px 34px;
        color: #FFF;

        @media all and (max-width: $breakpoint) {
            padding: 20px 15px;
        }
    }

    [data-page="faq"] .footer,
    [data-page="contact-us"] .footer {
        margin-top: 0;
    }


    .links {
        display: flex;
        margin-top: 31px;

        @media all and (max-width: $breakpoint) {
            margin-top: 20px;
            flex-wrap: wrap;
            justify-content: space-between;
        }
    }


    .link-column {

        @media all and (max-width: $breakpoint) {
            margin-bottom: 20px;
            width: 40%;
        }
    }

    .link-column:not(:first-child) {
        margin-left: 70px;

        @media all and (max-width: $breakpoint) {
            margin-left: 0;
        }
    }


    .links a {
        display: block;
        margin-top: 7px;
        max-width: max-content;
        line-height: 20px;
        font-weight: $book;
        font-size: 14px;
        color: inherit;
    }


    .copyright-info {
        margin-top: 40px;
        font-size: 14px;
        color: #B8B8B8;

        @media all and (max-width: $breakpoint) {
            margin-top: 20px;
            text-align: center;
        }
    }


    .social-links {
        position: absolute;
        display: flex;
        justify-content: space-between;
        right: 88px;
        bottom: 43px;
        width: 180px;

        @media all and (max-width: $breakpoint) {
            position: static;
            margin: 20px auto 0;
        }
    }


    .social-links a {
        display: inline-block;
        height: max-content;
    }


    .social-links img {
        width: 36px;
        height: 36px;
        object-fit: contain;
    }
</style>
